import { useLayoutEffect } from 'react';
import { useSplashStore } from './splash.store';

/**
 * Registers a named splash blocker while `active` is true.
 * Uses layout effect so child gates can claim the splash before parent gates release
 * it in the same commit (no gap / remount between bootstrap phases).
 */
export function useSplashBlocker(id: string, active: boolean) {
  const setBlocker = useSplashStore((state) => state.setBlocker);

  useLayoutEffect(() => {
    setBlocker(id, active);

    return () => {
      setBlocker(id, false);
    };
  }, [id, active, setBlocker]);
}
